import { DateTime } from "luxon";
import { toLocaleTH } from "@/lib/dateTime";
import { formatToMoney } from "@/lib/formatter";

export function mapCouponListItem(coupon) {
  const {
    id,
    code,
    effective_date: effectiveDateISO,
    expired_days_after_transfered: expiredDaysAfterTransfered,
    expiry_date: expiryDateISO,
    discount_amount: discountAmountVal,
    discount_percent_amount: discountPercentAmountVal,
    maximum_discount_amount: maximumDiscountAmountVal,
    minimum_purchased_amount: minimumPurchasedAmountVal,
    usage_quota: usageQuotaVal,
    usage_quota_per_user: usageQuotaPerUserVal,
    is_first_time_only: isFirstTimeOnly,
  } = coupon;
  const usageQuota = usageQuotaVal ? usageQuotaVal.toLocaleString() : "ไม่จำกัด";
  const usageQuotaPerUser = usageQuotaPerUserVal || "1";
  const discount = discountAmountVal
    ? `${formatToMoney(discountAmountVal)} บาท`
    : `${discountPercentAmountVal}%`;

  const effectiveDate = toLocaleTH(DateTime.fromISO(effectiveDateISO));
  const expiryDate = toLocaleTH(DateTime.fromISO(expiryDateISO));

  const isSameYear = effectiveDate.hasSame(expiryDate, "year");
  const isSameMonth = effectiveDate.hasSame(expiryDate, "month");

  const format = "d MMM yyyy";

  let usagePeriod = "";
  if (expiredDaysAfterTransfered === null) {
    if (!isSameYear) {
      usagePeriod = `${effectiveDate.toFormat(format)} - ${expiryDate.toFormat(format)}`;
    } else if (!isSameMonth) {
      usagePeriod = `${effectiveDate.toFormat("dd MMM")} - ${expiryDate.toFormat(format)}`;
    } else {
      usagePeriod = `${effectiveDate.toFormat("dd")} - ${expiryDate.toFormat(format)}`;
    }
  } else {
    usagePeriod = `${expiredDaysAfterTransfered} days from transfer date`;
  }

  const minimumPurchase = minimumPurchasedAmountVal
    ? `${formatToMoney(minimumPurchasedAmountVal)} บาท`
    : "ไม่มี";
  const maximumDiscount = maximumDiscountAmountVal
    ? `${formatToMoney(maximumDiscountAmountVal)} บาท`
    : "ไม่จำกัด";

  return {
    id,
    code,
    discount,
    usagePeriod,
    minimumPurchase,
    maximumDiscount,
    usageQuota,
    usageQuotaPerUser,
    route: {
      name: "CouponDetailPage",
      params: { id },
    },
    isFirstTimeOnly,
  };
}
